$window = $(window);
$document = $(document);
$body = $('body');


// cpb events: CPB_ON_PRODUCT_MOUNTED, CPB_ON_OPTIONS_UPDATE, CPB_ON_UPDATE_CURRENT_TAB, cpb-add-to-cart

(function customProduct() {
  var $price = $('cpb-product-full-price');
  var $pricePlaceholder = $('[data-cp-price]');
  var $atcBtn = $('[data-cp-atc]');
  var mounted = false;
  var configId;

  var nf = new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  // atc hijack
  $atcBtn.on('click', function(e) {
    e.preventDefault();
    $('.cpb-add-to-cart-button').trigger('click');
  });

  // ON: LOADED
  $body.on('CPB_ON_PRODUCT_MOUNTED', function(e) {
    console.log('CPB_ON_PRODUCT_MOUNTED', CPB.getStore().getState());
    mounted = true;

    // Expandables
    $('.cpb-panel-wrapper').filter(':first-child').addClass('open');
    $document.on('click', '.cpb-panel-title', function(e) {
      $('.cpb-panel-wrapper').removeClass('open');
      $(this).closest('.cpb-panel-wrapper').addClass('open');
    });

    // Move further info
    $('.cpb-panels-container').append($('[cp-more-info]'));
  });

  // ON: OPTIONS UPDATE
  $body.on('CPB_ON_OPTIONS_UPDATE', function(e) {

    // price update
    var price = CPB.getStore().getState().Product.price;
    $pricePlaceholder.text(nf.format(price));

    const product = CPB.getStore().getState().Product;
    let incompleteCategories = [];

    product.panels.forEach(panel => {
      let incompletePanelCategories = [];
      incompletePanelCategories = incompletePanelCategories.concat(panel.categories.filter(category => {
        return (panel.requiredPanel || panel.askRequiredOptions || category.required) && !product.layers.find(layer => layer.category === category.id);
      }));

      $('.cpb-panel-title').filter(function() {
        return this.innerHTML == panel.title && !incompletePanelCategories.length;
      }).addClass('is-complete');

      incompleteCategories = incompletePanelCategories;
    });

    // if (!incompleteCategories.length) {
    //   console.log('all complete');
    //   $('[data-cp-atc]').prop(disabled, )
    // }

    if (mounted) {
      configId = window._cpb.saveConfig(null, false);

      // Share config id
      $('[data-cp-share]').each(function() {
        var $sharer = $(this);
        var attribute = $sharer.is('input') ? 'value' : 'href';
        var value = $sharer.attr(attribute);
        var newValue = value.replace('configid=', 'configid='+configId);
        $sharer.attr(attribute, newValue);
      });
    }
  });

})();
